
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/setmana-a-cardedeu",
      function () {
        return require("private-next-pages/setmana-a-cardedeu.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/setmana-a-cardedeu"])
      });
    }
  